module.exports = __webpack_public_path__ + "media/images/btn_create_account-1e0806291ca53f6278a2d232677ff5e9.gif";